import React, { useEffect, useState } from "react";
import { Button } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

import style from "./style";
import { IconClose } from "../../../../../../../UI/Icons";
import { UIOutlineButton } from "../../../../../../../UI/Buttons";
import { IFormElementUpdate } from "../../Interfaces/Form/FormElement/IFormElementUpdate";
import { EditFormHelper } from "../../Helpers/Forms/Edit";
import { FormBuilder } from "../Builder";
import { IForm } from "../../Interfaces/Form/IForm";
import { CircularProgress } from "../../../../../../../UI/Progress";
import { IFormElement } from "../../Interfaces/Form/FormElement/IFormElement";
import { IOption } from "../../../../../../../UI/Elements/Forms/interface/IOption";
import { FormElementHelper } from "../../Helpers/Forms/Element";
import { ValidationHelper } from "../../Helpers/Validations";
import {IScheduleSelectedJobInfo} from "../../Interfaces/IScheduleSelectedJobInfo";


// Create styles
const useStyles = makeStyles((theme: Theme) => createStyles(style(theme)));

type props = {
  formTitle: string;
  toggleDrawer: any;
  btnSaveText: string;
  btnCancelText: string;
  onSave: any;
  onCancel: any;
  formData: any;
  width?: number;
  isFilterForm: boolean;
  resetText?: string;
  onReset?: any;
  selectedScheudledInfo: IScheduleSelectedJobInfo;
};

export const SidebarFormComponent: any = (props: props): React.JSX.Element => {
  const {
    formTitle,
    formData,
    btnSaveText,
    btnCancelText,
    onSave,
    onCancel,
    width,
    selectedScheudledInfo
  } = props;
  const classes = useStyles();
  const [form, setForm] = useState<IForm>(formData);
  const [loading, setLoading] = useState<boolean>(false);
  const [disable, setDisable] = useState<boolean>(!form.isValid);

  const onCreateOption = (formElement: IFormElement, option: IOption): void => {
    const editFormHelper = new EditFormHelper();
    const Form = editFormHelper.updateElementDataSource(
      form,
      formElement,
      option
    );
    setForm(Form);
  };

  const onFormChange = async (element: IFormElementUpdate): Promise<void> => {
    const editFormHelper = new EditFormHelper();
    const formElementHelper = new FormElementHelper();
    let Form = await editFormHelper.updateForm(form, element, selectedScheudledInfo);
    Form = formElementHelper.findDisabledEle(
      Form,
      element
    );
    Form = formElementHelper.findDependentEle(
      Form,
      element
    );
    const validationHelper = new ValidationHelper();
    Form = validationHelper.isValidForm(Form);
    setDisable(!Form.isValid);
    setLoading(false);
    setForm(Form);
  };
  useEffect(() => {
    setForm(formData);
  }, []);

  return (
    <>
      <div
        className={classes.sideBarContainer}
        style={{
          width: width || 450,
        }}
        role="presentation"
      >
        <div className={classes.sidebarHeader}>
          <div className={classes.sideBarTitle}>{formTitle}</div>
          <span style={{ paddingLeft: "20px" }}><IconClose onClick={onCancel} title="" /></span>
        </div>
        <FormBuilder
          form={form}
          onChange={onFormChange}
          onCreateOption={onCreateOption}
        />
      </div>
      <div
        className={classes.actionContainer}
        style={{
          width: width || 424,
        }}
      >

        <UIOutlineButton
          isOutline={true}
          onClick={onCancel}
          btnText={btnCancelText}
          cssStyle={{
            marginRight: "0.75rem",
          }}
        />
        <Button
          variant="contained"
          color="primary"
          disabled={disable}
          onClick={() => {
            onSave(form);
          }}
        >
          {btnSaveText}
        </Button>
      </div>
      {loading && <CircularProgress />}
    </>
  );
};
